import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import WeightLoss from './pages/WeightLoss';
import ProductDetail from './pages/ProductDetail';
import Quiz from './pages/Quiz';
import AdminSubmissions from './pages/AdminSubmissions';
import Admin from './pages/Admin';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Refund from './pages/Refund';
import TreatmentSelection from './pages/TreatmentSelection';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import Results from './pages/Results';
import Qualifying from './pages/Qualifying';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<WeightLoss />} />
          <Route path="/weight-loss" element={<WeightLoss />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/weight-loss/quiz" element={<Quiz />} />
          <Route path="/weight-loss/results" element={<Results categorySlug="weight-loss" />} />
          <Route path="/weight-loss/qualifying" element={<Qualifying categorySlug="weight-loss" />} />
          <Route path="/weight-loss/treatments" element={<TreatmentSelection categorySlug="weight-loss" />} />
          <Route path="/checkout/:slug" element={<Checkout />} />
          <Route path="/checkout/:slug/confirmation" element={<OrderConfirmation />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/submissions" element={<AdminSubmissions />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
